// src/hooks/useCourses.js

import { useState, useEffect } from "react";

export const useCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/get_courses.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setCourses(data.data);
        } else {
          console.error("Ungültige Kursdaten erhalten.");
        }
      })
      .catch((err) => console.error("Kursdaten konnten nicht geladen werden:", err))
      .finally(() => setLoading(false));
  }, []);

  return { courses, loading };
};
